var ezdia;
(function (ezdia) {
    var pageParams = {};
    var accountKey = null;
    var setDefaultValues = function () {
        var role = $('#role')
            .off('change')
            .val(pageParams.role)
            .change(function change() {
            var accountName = pageParams.account;
            var params = "role=" + this.value;
            if (accountName) {
                params += "&accountName=" + accountName;
            }
            var itemParams = getItemParams();
            if (itemParams) {
                params += itemParams;
            }
            window.location.href = "Item.htm?" + params;
        });
        var account = $('#accountName')
            .val(pageParams.account)
            .change(function change() {
            var size = pageParams.size;
            var params = "accountName=" + this.value;
            if (size) {
                params += "&size=" + size;
            }
            var itemParams = getItemParams();
            if (itemParams) {
                params += itemParams;
            }
            window.location.href = "Item.htm?" + params;
        });
        var template = $('#template')
            .val(pageParams.template)
            .change(function () {
            var accountName = pageParams.account;
            var params = "role=" + pageParams.role;
            if (accountName) {
                params += "&accountName=" + accountName;
            }
            params += "&template=" + $('#template').val();
            var itemParams = getItemParams();
            if (itemParams) {
                params += itemParams;
            }
            window.location.href = "Item.htm?" + params;
        });
        role.sortItems().chosen({
            placeholder_text: '',
            disable_search_threshold: 10
        });
        account.sortItems().chosen({
            placeholder_text: '',
            disable_search_threshold: 10
        });
        template.sortItems().chosen({
            placeholder_text: '',
            disable_search_threshold: 10
        });
    };
    function getItemParams() {
        var e_1, _a;
        var itemParams = '';
        var queryStr = pageParams.queryStr;
        if (queryStr !== null) {
            var params = queryStr.split('&');
            try {
                for (var params_1 = __values(params), params_1_1 = params_1.next(); !params_1_1.done; params_1_1 = params_1.next()) {
                    var param = params_1_1.value;
                    var nameVal = param.split('=');
                    var name_1 = nameVal[0];
                    var val = nameVal[1];
                    if (name_1 &&
                        val &&
                        name_1 !== 'accountName' &&
                        name_1 !== 'role' &&
                        name_1 !== 'template') {
                        itemParams += "&" + name_1 + "=" + val;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (params_1_1 && !params_1_1.done && (_a = params_1.return)) _a.call(params_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return itemParams;
    }
    var checkLocalStorage = function () {
        var frm = pageParams.frm;
        pageParams.localStorageObj = {
            accountKey: accountKey,
            cols: pageParams.column
        };
        if (pageParams.message) {
            frm.localStorage('discard', { accountKey: accountKey });
        }
        frm.localStorage(pageParams.localStorageObj);
        $('#createitembtn').on('click', function () {
            if (frm.valid()) {
                frm.localStorage('discard', { accountKey: accountKey });
            }
        });
    };
    var validate = function () {
        var validObj = {};
        $.each(pageParams.column, function (i, column) {
            $.ezdia.validate.init(validObj, column);
        });
        $.ezdia.validate.create(validObj, pageParams.frm, true);
    };
    var newItemObj = {
        load: function () {
            pageParams = $.ezdia.config.pageParams;
            accountKey = pageParams.account + "." + pageParams.role + "." + pageParams.module + "." + pageParams.template;
            pageParams.frm = $('#createitem');
            setDefaultValues();
            $.ezdia.groupFormField.jspGroup('#ez-content');
            $.ezdia.widgets.renderAll(pageParams.column, pageParams.module);
            validate();
            $('#ez-but-wrapper').show();
            pageParams.frm.keydown(function (e) { return e.keyCode !== 13; });
            if (pageParams.storage) {
                checkLocalStorage();
            }
        }
    };
    var pages;
    (function (pages) {
        pages.newItem = newItemObj;
    })(pages = ezdia.pages || (ezdia.pages = {}));
    /*
     ** This $.ezdia is just for old code support
     ** DON'T USE THIS
     */
    $.ezdia.newItem = newItemObj;
})(ezdia || (ezdia = {}));
